<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-text>
            <v-container>
              <!-- <div class="red--text">{{ msg }}</div> -->
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="formData.name"
                    label="Enter Name"
                    required
                    dense
                    :rules="[rules.required]"
                    type="text"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="formData.count"
                    label="Enter count"
                    required
                    dense
                    :rules="[rules.required]"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    outlined
                    class="my-5"
                    label="Enter Description"
                    v-model="formData.note"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save" :loading="sending"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>

    <v-card-title>
      <v-btn color="primary" class="mr-4" @click="dialog = true" rounded>
        Add Inventory
      </v-btn>

      <v-spacer></v-spacer>
    </v-card-title>
  </div>
</template>


<script>
import { inventory as api } from "@/api";
export default {
  name: "List",
  data: () => ({
    valid: true,
    loading: false,
    dialog: false,
    formTitle: "Add New Inventory",
    formData: {
      name: "",
      count: "",
      note: "",
    },
    sending: false,
    rules: {
      required: (v) => !!v || "Field is required",
      email: (v) => /.+@.+/.test(v) || "E-mail must be valid",
    },
  }),
  props: ["method"],
  methods: {
    // getListItem() {
    //   this.method();
    // },
    close() {
      this.dialog = false;
    },
    async save() {
      if (this.$refs.form.validate()) {
        try {
          this.sending = true;
          // console.log(this.name, this.count);
          await api.addItem(this.formData);
          this.sending = false;
          this.sending = false;
          this.$toast.success("Data Edit Successfully");
          this.method();
          this.close();
          this.$refs.form.reset();
        } catch (error) {
          this.sending = false;
          alert("Please write Correct data");
          this.close();
        }
      }
    },

    closeItem() {
      this.activeItem = null;
    },
  },
};
</script>